"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var default_1 = __importDefault(require("./config/default"));
var baurde_1 = __importDefault(require("./config/baurde"));
var imwalkingde_1 = __importDefault(require("./config/imwalkingde"));
var quellede_1 = __importDefault(require("./config/quellede"));
var quellech_1 = __importDefault(require("./config/quellech"));
var quelleat_1 = __importDefault(require("./config/quelleat"));
var ottoversandat_1 = __importDefault(require("./config/ottoversandat"));
var universalat_1 = __importDefault(require("./config/universalat"));
var ackermannch_1 = __importDefault(require("./config/ackermannch"));
var jelmolich_1 = __importDefault(require("./config/jelmolich"));
var tenantComponentConfig = {
    emma: default_1.default,
    baurde: baurde_1.default,
    imwalkingde: imwalkingde_1.default,
    quellede: quellede_1.default,
    quellech: quellech_1.default,
    quelleat: quelleat_1.default,
    ottoversandat: ottoversandat_1.default,
    universalat: universalat_1.default,
    ackermannch: ackermannch_1.default,
    jelmolich: jelmolich_1.default,
};
var componentConfig = function (_a) {
    var _b = _a.companyId, companyId = _b === void 0 ? 'emma' : _b;
    return tenantComponentConfig["" + companyId] || default_1.default;
};
exports.default = componentConfig;
//# sourceMappingURL=index.js.map